export default "__VITE_ASSET__a09a4be4__"